import { render, staticRenderFns } from "./Policy.List.vue?vue&type=template&id=7a6e5b31&"
import script from "./Policy.List.vue?vue&type=script&lang=js&"
export * from "./Policy.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports